import { Text, Skeleton } from "@chakra-ui/react";
import { SectionCard } from "../../../shared/ui";
import { formatarMesAno } from "../../../shared/lib/date";
import { usePlantoesQuery } from "../../plantoes/hooks/usePlantoesQuery";
import BulkStatusBar from "../../plantoes/components/BulkStatusBar";

// Atalho para o dia de emitir a nota / receber: depois de gerar a comprovação de um
// vínculo, muda o status de todos os plantões daquele vínculo no mês de uma vez. Busca a
// lista viva (não o snapshot da comprovação, que fica congelado de propósito). Plantões
// agendados ficam de fora, como no demonstrativo (ExcluirAgendados no backend).
export default function PeriodShiftsStatusCard({ vinculoId, vinculoNome, ano, mes }) {
  const { data, isLoading } = usePlantoesQuery({ vinculoId, ano, mes });
  const shifts = (data?.plantoes ?? []).filter((shift) => shift.schedule_status !== "scheduled");

  if (isLoading) return <Skeleton height="72px" borderRadius="xl" />;
  if (shifts.length === 0) return null;

  return (
    <SectionCard title="Atualizar status dos plantões">
      <BulkStatusBar
        shifts={shifts}
        summary={`${shifts.length} plantão(ões) de ${vinculoNome ?? "este vínculo"} em ${formatarMesAno(ano, mes)}`}
      />
      <Text fontSize="xs" color="app-muted-fg" mt={2}>
        O demonstrativo já gerado continua como foi emitido; os novos status aparecem em Recebíveis e nas próximas comprovações.
      </Text>
    </SectionCard>
  );
}
